function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { isArray as z, isEqual as ii } from "../util/code-utils.js";
import ti from "../models/push-token.js";
import { logger as N, EncodingUtils as ei } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { User } from "../User/index.js";
import vt from "./utils/push-utils.js";
import { getErrorMessage as si } from "../util/error-utils.js";

var na = /*#__PURE__*/function () {
  function na(i, t, e, s, r, n, o, u, a, h, c) {
    _classCallCheck(this, na);

    this.un = i, this.an = t, this.hn = e, this.cn = r, this.fn = n, this.ln = o, this.B = u, this.dn = a, this.pn = h, this.C = c, this.un = i, this.an = t, this.hn = e, this.bn = s + "/safari/" + t, this.cn = r || "/service-worker.js", this.ln = o, this.B = u, this.dn = a || !1, this.pn = h || !1, this.C = c, this.yn = vt.mn(), this.gn = vt.vn();
  }

  _createClass(na, [{
    key: "wn",
    value: function wn() {
      return this.pn;
    }
  }, {
    key: "kn",
    value: function kn(i, t, e, s, r) {
      var _this = this;

      i.unsubscribe().then(function (i) {
        i ? _this.Pn(t, e, s, r) : (N.error("Failed to unsubscribe device from push."), "function" == typeof r && r(!1));
      }).catch(function (i) {
        N.error("Push unsubscription error: " + i), "function" == typeof r && r(!1);
      });
    }
  }, {
    key: "Dn",
    value: function Dn(i, t, e) {
      var s;

      var r = function (i) {
        if ("string" == typeof i) return i;
        if (0 !== i.endpoint.indexOf("https://android.googleapis.com/gcm/send")) return i.endpoint;
        var t = i.endpoint;
        var e = i;
        return e.Sn && -1 === i.endpoint.indexOf(e.Sn) && (t = i.endpoint + "/" + e.Sn), t;
      }(i);

      var n = null,
          o = null;
      var u = i;
      if (null != u.getKey) try {
        var _i = Array.from(new Uint8Array(u.getKey("p256dh"))),
            _t = Array.from(new Uint8Array(u.getKey("auth")));

        n = btoa(String.fromCharCode.apply(null, _i)), o = btoa(String.fromCharCode.apply(null, _t));
      } catch (i) {
        N.error(si(i));
      }

      var a = function (i) {
        var t;
        return i.options && (t = i.options.applicationServerKey) && t.byteLength && t.byteLength > 0 ? btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(t)))).replace(/\+/g, "-").replace(/\//g, "_") : null;
      }(u);

      null === (s = this.un) || void 0 === s || s.An(r, t, n, o, a), r && "function" == typeof e && e(r, n, o);
    }
  }, {
    key: "jn",
    value: function jn() {
      var i;
      null === (i = this.un) || void 0 === i || i.xn(!0);
    }
  }, {
    key: "Nn",
    value: function Nn(i, t) {
      var e;
      null === (e = this.un) || void 0 === e || e.xn(!1), N.info(i), "function" == typeof t && t(!1);
    }
  }, {
    key: "Un",
    value: function Un(i, t, e, s) {
      var _this2 = this;

      var r;
      if ("default" === t.permission) try {
        window.safari.pushNotification.requestPermission(this.bn, i, {
          api_key: this.an,
          device_id: (null === (r = this.hn) || void 0 === r ? void 0 : r.ve().id) || ""
        }, function (t) {
          "granted" === t.permission && _this2.un && _this2.un.setPushNotificationSubscriptionType(User.NotificationSubscriptionTypes.OPTED_IN), _this2.Un(i, t, e, s);
        });
      } catch (i) {
        this.Nn("Could not request permission for push: " + i, s);
      } else "denied" === t.permission ? this.Nn("The user has blocked notifications from this site, or Safari push is not configured in the Braze dashboard.", s) : "granted" === t.permission && (N.info("Device successfully subscribed to push."), this.Dn(t.deviceToken, new Date(), e));
    }
  }, {
    key: "requestPermission",
    value: function requestPermission(i, t, e) {
      var s = function s(_s) {
        switch (_s) {
          case "granted":
            return void ("function" == typeof i && i());

          case "default":
            return void ("function" == typeof t && t());

          case "denied":
            return void ("function" == typeof e && e());

          default:
            N.error("Received unexpected permission result " + _s);
        }
      };

      var r = !1;
      if ("default" !== window.Notification.permission) s(Notification.permission);else {
        var _i2 = window.Notification.requestPermission(function (i) {
          r && s(i);
        });

        _i2 ? _i2.then(function (i) {
          s(i);
        }) : r = !0;
      }
    }
  }, {
    key: "Pn",
    value: function Pn(i, t, e, s) {
      var _this3 = this;

      var r = {
        userVisibleOnly: !0
      };
      null != t && (r.applicationServerKey = t), i.pushManager.subscribe(r).then(function (i) {
        N.info("Device successfully subscribed to push."), _this3.Dn(i, new Date(), e);
      }).catch(function (i) {
        vt.isPushBlocked() ? (N.info("Permission for push notifications was denied."), "function" == typeof s && s(!1)) : (N.error("Push subscription failed: " + i), "function" == typeof s && s(!0));
      });
    }
  }, {
    key: "Wn",
    value: function Wn() {
      if (this.dn) return navigator.serviceWorker.getRegistration(this.cn);
      var i = this.fn ? {
        scope: this.fn
      } : void 0;
      return navigator.serviceWorker.register(this.cn, i).then(function () {
        return navigator.serviceWorker.ready.then(function (i) {
          return i && "function" == typeof i.update && i.update().catch(function (i) {
            N.info("ServiceWorker update failed: " + i);
          }), i;
        });
      });
    }
  }, {
    key: "_n",
    value: function _n(i) {
      this.dn || (i.unregister(), N.info("Service worker successfully unregistered."));
    }
  }, {
    key: "subscribe",
    value: function subscribe(i, t) {
      var _this4 = this;

      if (!vt.isPushSupported()) return N.info(na.Tn), void ("function" == typeof t && t(!1));

      if (this.yn) {
        if (!this.dn && null != window.location) {
          var _i3 = this.cn;
          -1 === _i3.indexOf(window.location.host) && (_i3 = window.location.host + _i3), -1 === _i3.indexOf(window.location.protocol) && (_i3 = window.location.protocol + "//" + _i3);
        }

        if (vt.isPushBlocked()) return void this.Nn("Notifications from this site are blocked. This may be a temporary embargo or a permanent denial.", t);
        if (this.B && !this.B.In() && 0 === this.B.Et()) return N.info("Waiting for VAPID key from server config before subscribing to push."), void this.B.Vn(function () {
          _this4.subscribe(i, t);
        });

        var e = function e() {
          N.info("Permission for push notifications was denied."), "function" == typeof t && t(!1);
        },
            r = function r() {
          var i = "Permission for push notifications was ignored.";
          vt.isPushBlocked() && (i += " The browser has automatically blocked further permission requests for a period (probably 1 week)."), N.info(i), "function" == typeof t && t(!0);
        },
            n = vt.isPushPermissionGranted(),
            o = function o() {
          !n && _this4.un && _this4.un.setPushNotificationSubscriptionType(User.NotificationSubscriptionTypes.OPTED_IN), _this4.Wn().then(function (e) {
            if (null == e) return N.error("No service worker registration. Set the `manageServiceWorkerExternally` initialization option to false or ensure that your service worker is registered before calling registerPush."), void ("function" == typeof t && t(!0));
            e.pushManager.getSubscription().then(function (r) {
              var n;
              var o = null;

              if (null != (null === (n = _this4.B) || void 0 === n ? void 0 : n.In()) && (o = ei.qn(_this4.B.In())), r) {
                var _n2,
                    u = null,
                    a = null;

                if (_this4.C && (_n2 = _this4.C.ft(s.gt.zn)), _n2 && !z(_n2)) {
                  var _i4;

                  try {
                    _i4 = ti.Rn(_n2).En;
                  } catch (t) {
                    _i4 = null;
                  }

                  null == _i4 || isNaN(_i4.getTime()) || 0 === _i4.getTime() || (u = _i4, a = new Date(u), a.setMonth(u.getMonth() + 6));
                }

                null != o && r.options && r.options.applicationServerKey && r.options.applicationServerKey.byteLength && r.options.applicationServerKey.byteLength > 0 && !ii(o, new Uint8Array(r.options.applicationServerKey)) ? (r.options.applicationServerKey.byteLength > 12 ? N.info("Device was already subscribed to push using a different VAPID provider, creating new subscription.") : N.info("Attempting to upgrade a gcm_sender_id-based push registration to VAPID - depending on the browser this may or may not result in the same gcm_sender_id-based subscription."), _this4.kn(r, e, o, i, t)) : r.expirationTime && new Date(r.expirationTime).valueOf() <= new Date().valueOf() ? (N.info("Push subscription is expired, creating new subscription."), _this4.kn(r, e, o, i, t)) : _n2 && z(_n2) ? _this4.kn(r, e, o, i, t) : null == a ? (N.info("No push subscription creation date found, creating new subscription."), _this4.kn(r, e, o, i, t)) : a.valueOf() <= new Date().valueOf() ? (N.info("Push subscription older than 6 months, creating new subscription."), _this4.kn(r, e, o, i, t)) : (N.info("Device already subscribed to push, sending existing subscription to backend."), _this4.Dn(r, u, i));
              } else _this4.Pn(e, o, i, t);
            }).catch(function (i) {
              N.error("Error checking current push subscriptions: " + i);
            });
          }).catch(function (i) {
            N.error("ServiceWorker registration failed: " + i);
          });
        };

        this.requestPermission(o, r, e);
      } else if (this.gn) {
        if (null == this.ln || "" === this.ln) return N.error("You must supply the safariWebsitePushId initialization option in order to use registerPush on Safari"), void ("function" == typeof t && t(!0));

        var _e = window.safari.pushNotification.permission(this.ln);

        this.Un(this.ln, _e, i, t);
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(i, t) {
      var _this5 = this;

      if (!vt.isPushSupported()) return N.info(na.Tn), void ("function" == typeof t && t());
      this.yn ? navigator.serviceWorker.getRegistration(this.cn).then(function (e) {
        e ? e.pushManager.getSubscription().then(function (s) {
          s ? (_this5.jn(), s.unsubscribe().then(function (s) {
            s ? (N.info("Device successfully unsubscribed from push."), "function" == typeof i && i()) : (N.error("Failed to unsubscribe device from push."), "function" == typeof t && t()), _this5._n(e);
          }).catch(function (i) {
            N.error("Push unsubscription error: " + i), "function" == typeof t && t();
          })) : (N.info("Device already unsubscribed from push."), "function" == typeof i && i());
        }).catch(function (i) {
          N.error("Error unsubscribing from push: " + i), "function" == typeof t && t();
        }) : (N.info("Device already unsubscribed from push."), "function" == typeof i && i());
      }) : this.gn && (this.jn(), N.info("Device unsubscribed from push."), "function" == typeof i && i());
    }
  }]);

  return na;
}();

export { na as default };
na.Tn = "Push notifications are not supported in this browser.";